module.exports = __webpack_public_path__ + "img/checkbox-disabled-checked.f65c0445.svg";